module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-76x76-precomposed-7b5a97c645e2f538a7c96ed629e88f16.png";